import React from "react";
import { Helmet } from "react-helmet-async";
import { Row, Col, Card } from "react-materialize";
import $ from "jquery";
import "./About.css";

const PAUL_PROFILE_URL = "https://bridgechampions.com/about";
const PAUL_IMAGE_URL =
  "https://firebasestorage.googleapis.com/v0/b/bridgechampions.appspot.com/o/logo.png?alt=media&token=583808ab-2c3b-49a6-8936-82dffe55ec95";

const ACHIEVEMENTS = [
  { year: "2026", text: "1st place: Spring Nationals Open Teams" },
  { year: "2026", text: "1st place: ANC Open Butler Pairs (Australian National Championships)" },
  { year: "2026", text: "Qualified for the Australian team" },
  { year: "2026", text: "1st place: National Open Teams (Canberra)" },
  { year: "2026", text: "1st place: South West Pacific Teams (Canberra)" },
  { year: "2025", text: "1st place: Gold Coast Pairs" },
  { year: "2025", text: "1st place: Adelaide Open Teams" },
  { year: "2025", text: "1st place: New Zealand Open Teams" },
];

const personJsonLd = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": "https://bridgechampions.com/#author",
  name: "Paul Dalley",
  url: PAUL_PROFILE_URL,
  image: PAUL_IMAGE_URL,
  jobTitle: "Bridge teacher",
  description: "Paul Dalley, founder of Bridge Champions.",
  knowsAbout: [
    "Contract bridge",
    "Bridge bidding systems",
    "Bridge declarer play",
    "Bridge defence",
    "Bridge conventions",
    "Bridge teaching",
  ],
  worksFor: {
    "@id": "https://bridgechampions.com/#organization",
  },
  award: ACHIEVEMENTS.map((a) => `${a.year} — ${a.text}`),
  sameAs: [
    "https://www.youtube.com/@BridgeChampions",
  ],
};

const aboutPageJsonLd = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  url: PAUL_PROFILE_URL,
  name: "About Paul Dalley",
  description: "Paul Dalley's recent bridge achievements.",
  mainEntity: {
    "@id": "https://bridgechampions.com/#author",
  },
  publisher: {
    "@id": "https://bridgechampions.com/#organization",
  },
};

class About extends React.Component {
  componentDidMount() {
    $("html, body").animate({ scrollTop: 0 }, 800);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>About Paul Dalley &mdash; Bridge Champions</title>
          <meta
            name="description"
            content="Paul Dalley's recent bridge achievements."
          />
          <link rel="canonical" href={PAUL_PROFILE_URL} />
          <meta property="og:type" content="profile" />
          <meta property="og:url" content={PAUL_PROFILE_URL} />
          <meta
            property="og:title"
            content="About Paul Dalley"
          />
          <meta
            property="og:description"
            content="Paul Dalley's recent bridge achievements."
          />
          <meta property="og:site_name" content="Bridge Champions" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="About Paul Dalley" />
          <meta
            name="twitter:description"
            content="Paul Dalley's recent bridge achievements."
          />
          <script type="application/ld+json">{JSON.stringify(personJsonLd)}</script>
          <script type="application/ld+json">{JSON.stringify(aboutPageJsonLd)}</script>
        </Helmet>

        <div className="About-container">
          <Row>
            <Col s={12} m={10} l={8} offset="m1 l2">
              <Card className="About-card">
                <h1 className="About-title">About Paul Dalley</h1>

                <div className="About-content">
                  <section className="About-section" id="paul-dalley">
                    <h2>Recent achievements</h2>
                    <ul className="About-achievements">
                      {ACHIEVEMENTS.map((a) => (
                        <li key={`${a.year}-${a.text}`}>
                          <strong>{a.year}</strong> &mdash; {a.text}
                        </li>
                      ))}
                    </ul>
                  </section>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default About;
